angular
    .module('dnecom.component.product')
    .service('ProductFrontendUtils', function () {
        this.price = function(product) {
            var price;

            if (product.currentPrice) {
                price = product.currentPrice;
            } else {
                price = product.regularPrice;
            }

            var parsed = parseFloat(price);

            if (isNaN(parsed) || parsed == 0) {
                price = null;
            }

            return price;
        };

        this.url = function(product, mobile, anchor) {
            if (product.slug) {
                var route = Routing.generate('stores_fe_product_slug' + (mobile ? '_mobile' : ''), {
                    productSlug: product.slug
                });
                if (anchor) {
                    route = route + '#' + anchor;
                }

                return  route;
            }

            var route = Routing.generate('stores_fe_product' + (mobile ? '_mobile' : ''), {
                productId: product.id
            });

            if (anchor) {
                route = route + '#' + anchor;
            }

            return  route;
        }

        this.categoryUrl = function(slug, mobile) {
            return Routing.generate('stores_fe_category' + (mobile ? '_mobile' : ''), {
                slug: slug
            });
        }
    });
